<template>
    <div class="classManage">
        <div class="selectHead">
            <span>{{studentsList.className}}</span>
        </div>
        <div class="classContent">
            <div class="studentsList">
                <div class="listTitle">
                    <span v-for="(item,index) in selectTitle" :key="index" :class="{'select': changeStyle == index}" @click="toggle(index)">{{item.title}}</span>
                </div>
                <div class="table clearfix" v-if="changeStyle == 0">
                    <div class="tableHead">
                        <ul>
                            <li>姓名</li>
                            <li>账号</li>
                            <li>状态</li>
                            <li>所在小组</li>
                        </ul>
                    </div>
                    <div class="tableBody">
                        <ul v-for="(item,index) in newStuList" :key="index" v-if="item.userRole == 1">
                            <li>{{item.userName}}</li>
                            <li>{{item.userId}}</li>
                            <li>{{item.phone ? '已激活' : '未激活'}}</li>
                            <li>{{(item.teamName == "未分组") ? '-': item.teamName }}</li>
                        </ul>
                    </div>
                </div>
            </div>
            <groups v-if="changeStyle == 1"  :index="classIndex" ></groups>
        </div>
    </div>
</template>

<script>
import fetch from "./../../fetch";
import groups from "./group";
export default {
  data() {
    return {
      selectTitle: [{ title: "学生列表" }, { title: "小组管理" }],
      changeStyle: 0,
      newStuList: [],
      classIndex: "",
      classId: '',
      studentsList: ''
    };
  },
  components: {
    groups
  },
  created() {
    this.$nextTick(() => {
      this.getClass();
    });
  },
  watch: {
    $route: "getClass"
  },
  methods: {
    toggle(index) {
      this.changeStyle = index;
      this.getClass()
    },

    // clildData(val) {
    //   console.log(val);
    //   if (val) {
    //     let param = {
    //       classIds: this.classId,
    //       userRole: 1
    //     };
    //     this.getStuList(param);
    //   }
    // },

    getClass() {
      this.classIndex = this.$route.query.index;
      this.studentsList = JSON.parse(window.sessionStorage.getItem("studentsListData"))[this.classIndex];
      this.newStuList = this.studentsList.data;
      this.classId = this.studentsList.classId
      console.log(this.studentsList)
    },

    
    // 获取班级数据
    getStuList(param) {
      fetch.getMemberlist(param).then(res => {
        if (!res) {
          return false;
        }
        let newData = res.data[0];
        let students = this.getGroups(newData.data);
        let studentsListData = JSON.parse(
          window.sessionStorage.getItem("studentsListData")
        );
        window.sessionStorage.setItem("studentsListData", "");
        for (let i = 0, len = studentsListData.length; i < len; i++) {
          let item = studentsListData[i];
          let arr = [];
          if (newData.classId == item.classId) {
            item.students = students;
            item.data = newData.data
            students.newStu.map(sItem => {
              arr.push(sItem);
            });
            item.students = arr;
            break;
          }
        }
        window.sessionStorage.setItem(
          "studentsListData",
          JSON.stringify(studentsListData));
        this.getClass()
        console.log(studentsListData, "new");
      });
    },

    // 获取班级的分组，对分组进行处理
    getGroups(students) {
      let group = {};
      let newStu = [];
      let groupTitles = [];
      let student_count = 0;
      students.sort((a, b) => {
        return a.userName.localeCompare(b.userName);
      });
      for (let index = 0, len = students.length; index < len; index++) {
        let item = students[index];
        if (item.userRole === 2) {
          // 过滤掉教师本身
          continue;
        }
        item.teamName = item.teamName || "未分组";
        const same_index = groupTitles.indexOf(item.teamName);
        if (index === 0 || same_index < 0) {
          group = {
            title: item.teamName,
            data: [item],
            count: 1,
            teamShow: false,
            selNum: 0
          };
          groupTitles.push(group.title);
          newStu.push(group);
        } else {
          let group = newStu[same_index];
          group.data.push(item);
          group.count += 1;

          newStu[same_index] = group;
        }
        student_count++;
      }
      return { newStu, student_count };
    }

  }
};
</script>




// WEBPACK FOOTER //
// classManage.vue?4f8bf8d4